import React from 'react';
import {ExtGrid, LockedGrid, Panel,} from '@sencha/ext-react-modern';

import * as f from "../../../common/Funcs";
import PasTableSubGrid from "../../../Base/ZMU/PasTableSubGrid";
import ErrorBoundary from "../../../ErrorBoundary";

const keyName = `PasTable2SubGrid`;
const Ext = window['Ext'];
Ext.require('Ext.grid.plugin.Summary');

export default class PasTable2SubGrid extends PasTableSubGrid {

    constructor(props) {
        super(props);
        const context = this;
        // context.rowNumberWidth = 40;
        context.tableId = 'pas_erase_data'
        context.columnsDefaults = [
            {column_name: 'spec_id1', data_type: 'integer', pos: 1, hidden: true, width: 150},
            {
                column_name: 'spec_name1', data_type: 'text', pos: 2, width: 150, is_list: true,
                source: {
                    tableName: 'zmu_species',
                    idField: 'zmu_spec',
                    titleField: 'spec_name',
                    filterString: () => 'table_num=2&acc_year=' + document.getCookie('yearFilter')
                }
            },
            {column_name: 'days_old', data_type: 'integer', pos: 3, width: 250},
            {column_name: 'count_fst1', data_type: 'integer', pos: 4, width: 150},
            {column_name: 'count_fld1', data_type: 'integer', pos: 5, width: 150},
            {column_name: 'count_bog1', data_type: 'integer', pos: 6, width: 150},
        ];
        const storeProps = {
            data: context.state.data
        };
        context.store = Ext.create('Ext.data.Store', storeProps);
    }

    // componentDidMount = () => {
    //     const context = this;
    //     context.getRefData(context);
    // }

    getRefData(context) {
        const params = {
            context: context,
            tableName: 'zmu_species',
            idField: 'zmu_spec',
            titleField: 'spec_name',
            filterString: 'table_num=2&acc_year=' + document.getCookie('yearFilter'),
            callback: (result) => {
                context.setState({ref:result.data,species: result.data.map(d => d.value)});
            }
        };
        f.getRefData(params);
    }

    render() {
        // if (window.IasConfig.devMode) console.debug(`${keyName} render`);
        const context = this;
        const columns = [];
        const content = [];
        if (!context.inload) {
            window.unmask();
            /*заполнение полей для store*/
            context.store.fields = context.state.columns.filter(c => c.column_name !== context.idName);
            /*обработка ячейки с признаком редакции*/
            context.state.columns.sort((a, b) => (a.pos == null) ? 1 : a.pos - b.pos).map(c => {
                //const column = context.getExtColumn(c);
                const column = context.getColumn(context, c);
                /*форматирование ячеек*/
                columns.push(column);
            });
        }
        const itemConfig = (context.tpl) ? {
            body: {
                tpl: context.tpl()
            }
        } : {};
        //тело таблицы
        if (columns.length > 0) {
            const grid = context.getGrid(context, columns);
            content.push(grid);
            window.testGrid = grid;
            // content.push(context.getPaging(context, columns));
        }
        //панель инструментов гриды. Внутреннее меню страницы - в base...page
        content.push(context.getToolBar());

        return (<Panel key={keyName + 'pankey'}
                       ref={p => (p) ? (context.cmp = p.cmp) : context.cmp = null}
        >{content}</Panel>)
    }
}
